import React from 'react'
import { FacebookShareButton, TwitterShareButton, LineShareButton } from 'react-share'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons'
import lineIcon from '~/components/image/common_icon_line.svg'

export default function SNSShare({ title, link }) {
  return (
    <div className="shareIcons">
      <dl>
        <dt>SHARE</dt>
        <dd className="shareIconsTwitter">
          <TwitterShareButton title={title} url={link} via="">
            <FontAwesomeIcon icon={faTwitter} />
          </TwitterShareButton>
        </dd>
        <dd className="shareIconsFacebook">
          <FacebookShareButton url={link}>
            <FontAwesomeIcon icon={faFacebookF} />
          </FacebookShareButton>
        </dd>
        <dd className="shareIconsLine">
          <LineShareButton url={link}>
            <img src={lineIcon} alt="line icon" width="22" height="8" />
          </LineShareButton>
        </dd>
      </dl>
    </div>
  )
}
